import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phonenumber',
  standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    if (value.toString().length === 10) {
      return '(' + value.toString().slice(0, 3) + ') ' + value.toString().slice(3, 6) + '-' + value.toString().slice(6);
    } else {
      return value;
    }
  }
}
